import MuiAccordionDetails from "@material-ui/core/AccordionSummary";
import { withStyles } from "@material-ui/core/styles";

export const AccordionDetails = withStyles({
  root: {
    padding: "12px",
    borderTop: "1px dotted grey",
  },
})(MuiAccordionDetails);
